import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { PackageIcon, TruckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-slate-50 pt-16 md:pt-24 pb-32" data-id="element-109">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-slate-100 z-0" data-id="element-110" />

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 opacity-10 text-primary z-0 hidden lg:block" data-id="element-111">
        <TruckIcon className="w-64 h-64" data-id="element-112" />
      </div>
      <div className="absolute bottom-10 left-10 opacity-10 text-primary z-0 hidden lg:block" data-id="element-113">
        <PackageIcon className="w-48 h-48" data-id="element-114" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-115">
        <div className="max-w-3xl mx-auto text-center" data-id="element-116">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6" data-id="element-117">
            Emergency Delivery & Logistics Services Across the UK
          </h1>

          <p className="text-xl md:text-2xl text-primary font-medium mb-6" data-id="element-118">
            Global Universal Logistics provides fast, reliable emergency parcel
            delivery and professional driver supply services nationwide.
          </p>

          <p className="text-lg text-slate-600 mb-10 leading-relaxed" data-id="element-119">
            From same-day deliveries to long-term driver contracts, our
            experienced logistics network ensures your items arrive safely,
            quickly, and on time anywhere in the UK.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-120">
            <Link to="/quote" className="w-full sm:w-auto" data-id="element-121">
              <Button size="lg" className="w-full sm:w-auto text-lg px-8" data-id="element-122">
                Get a Quote
              </Button>
            </Link>
            <Link to="/contact" className="w-full sm:w-auto" data-id="element-123">
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-8 bg-white" data-id="element-124">
                Book Delivery
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}